import {useState, useCallback, useRef, BaseSyntheticEvent} from 'react'
import {ConfirmUpgradeModal} from 'components/modals/ConfirmUpgradeModal'

export const useConfirmUpgrade = (needUpgrade: boolean, handleSubmit: (e?: BaseSyntheticEvent) => Promise<void>) => {
  const [openModal, setOpenModal] = useState(false)
  const handleSubmitRef = useRef(handleSubmit)
  handleSubmitRef.current = handleSubmit

  const confirmUpgrade = useCallback(
    async (e: BaseSyntheticEvent) => {
      if (needUpgrade) {
        setOpenModal(true)
      } else {
        return await handleSubmitRef.current(e)
      }
    },
    [needUpgrade]
  )

  const confirmUpgradeModal = openModal ? (
    <ConfirmUpgradeModal
      onSubmit={async () => {
        setOpenModal(false)
        await handleSubmitRef.current()
      }}
      closeModal={() => {
        setOpenModal(false)
      }}
      openModal={openModal}
    />
  ) : null

  return {confirmUpgrade, confirmUpgradeModal}
}
